import { joinQuotedWithAnd } from '../tmpCopied/joinQuotedWithAnd';
import { UnitError } from './UnitError';
import { Unit } from './types';
import { unitToString } from './registry';

export class MultipleBaseUnitsError extends UnitError {
  constructor(baseUnits: Array<Unit>) {
    super(
      `Multiple base units found: ${joinQuotedWithAnd(
        baseUnits.map(unitToString)
      )}"`
    );
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MultipleBaseUnitsError);
    }
    Object.setPrototypeOf(this, MultipleBaseUnitsError.prototype);
  }

  static invariant: (b: boolean, baseUnits: Array<Unit>) => asserts b = (
    b,
    baseUnits
  ) => {
    if (!b) {
      throw new MultipleBaseUnitsError(baseUnits);
    }
  };
}
